const tickerItems = [
  '综艺收官夜散场通道提前十分钟开放，离场秩序良好',
  '创作者大会东门七点前已有人排队，队伍安静有序',
  '城市音乐节副歌段落全场灯牌同步亮起',
  '本周热榜三条主线：挑战赛、新梗扩散、周末活动',
  '漫展第二日场内互动区集中在场地中后段',
  '短篇展映周出口长凳成了临时观后感交换点',
];

export default function LiveTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section aria-label="实时瓜点播报" className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center gap-4 h-12 md:h-14 overflow-hidden">
          <span className="shrink-0 flex items-center gap-2 text-xs md:text-sm font-medium text-accent-400">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时播报
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee">
              {loop.map((text, index) => (
                <span
                  key={`${text}-${index}`}
                  className="flex items-center gap-3 px-6 text-xs md:text-sm text-background-200 whitespace-nowrap"
                >
                  {text}
                  <i className="ri-seedling-line text-primary-400"></i>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}